import get from 'lodash.get';

export const selectArticleGroup = (state) => get(state, 'articleGroup');

export const selectArticleGroupData = (state) => get(state, 'articleGroup.data');
